import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export default {
  namespaced: true,
  state: {
    orders: [],
    pageLength: 25,
  },
  getters,
  mutations,
  actions,
};
